/************************
* PRODUCT MOUSE OVER
*************************/
$(function() {
	$(".roll").css("opacity","0");
	$(".roll").hover(function () {
	$(this).stop().animate({
	opacity: .4
	}, 200);
	},
	function () {
	$(this).stop().animate({
	opacity: 0
	}, 200);
	});
});


$(function(){
	var timeout='false';
function equalHeight(group) {
	var tallest = 0;
	group.each(function() {
		var thisHeight = $(this).height();
		if(thisHeight > tallest) {
			tallest = thisHeight;
		}
	});
	group.height(tallest);
}

  var basketState = $.cookie('slideout_basket_state');
  var slideOutState = $.cookie('slideout_panel_state');
    if(basketState != 'hidden' && basketState != 'visible'){
      $.cookie('slideout_basket_state', 'hidden',{ path: '/' });  
    }
    
    if(slideOutState === 'hidden' && basketState === 'hidden'){
      $('#page').css({margin: '0 6px 0 6px'});
	 
    }else if(slideOutState === 'visible' && basketState === 'hidden'){
      $('#page').css({margin: '0 0px 0 284px'});
      
    }else if(slideOutState === 'hidden' && basketState === 'visible'){
      $('#page').css({margin: '0 234px 0 6px'});
	  
    }else if(slideOutState === 'visible' && basketState === 'visible'){
      $('#page').css({margin: '0 234px 0 284px'});
    }
  
    if(basketState === 'hidden'){
      $('#basket').css({width: '0px'});
      $('#basket .basket-toggle').css({right: '6px'});
      $('#basket').addClass('closed').removeClass('open');
    }
    if(slideOutState === 'hidden'){
      $('#slideOut').css({width: '0px'});
      $('.slideOut-toggle').css({left: '6px'}).addClass('closed').removeClass('open');
      $('#slideOut').addClass('closed').removeClass('open');
    }

    function setViewportHeight(){
      var viewportHeight = $(window).height();
      $('#slideOut,#basket,#page').css({'height':viewportHeight});
    }
    setViewportHeight();
    $(window).resize(function() {
    	setViewportHeight();
    });
    function setViewportWidth(animation){    
      var basketState = $.cookie('slideout_basket_state');
      var slideOutState = $.cookie('slideout_panel_state');
      var viewportWidth = $(window).width();
      var sidebar_width = 0;
      if(basketState != 'hidden'){
      	sidebar_width = sidebar_width + 234;
      }
      if(slideOutState != 'hidden'){
      	sidebar_width = sidebar_width + 284;
      }
		var pageWidth = viewportWidth - sidebar_width;
	  
		if(animation === true){
			$('#page').animate({width: pageWidth}, { duration: 700, queue: false }, 'easeInSine', function(){
			$(".nano").nanoScroller({ iOSNativeScrolling: true });		
		});
		}else{
			$('#page').css('width', pageWidth);
			$(".nano").nanoScroller({ iOSNativeScrolling: true });
		}


    }
    setViewportWidth(false);

    $(window).smartresize(function(){
    	setViewportWidth(true);
    });
/************************
* BASKET
*************************/
  function showBasket(){
    $('#basket').animate({width: '234px'},{ duration: 700, queue: false }, 'easeInSine', function(){}).css('overflow', 'visible').addClass('open').removeClass('closed').removeClass('empty');
    $('#basket .basket-toggle').animate({right: '234px'}, { duration: 700, queue: false }, 'easeInSine', function(){});
    var slideOutState = $.cookie('slideout_panel_state');
    var margin_settings = '';
    if(slideOutState === 'hidden'){
    	margin_settings = '0 234px 0 6px';
    }else{
    	margin_settings = '0 234px 0 284px';
    }
    $('#page').animate({margin:margin_settings},{ duration: 700, queue: false }, 'easeInSine', function(){});
    $.cookie('slideout_basket_state', 'visible',{ path: '/' });  

    setViewportWidth(true);
  }
  function hideBasket(){
    $('#basket').animate({width: '0px'},{ duration: 700, queue: false }, 'easeInSine', function(){}).css('overflow', 'visible');
    $('#basket .basket-toggle').animate({right: '6px'}, { duration: 700, queue: false }, 'easeInSine', function(){});
    $('#basket').removeClass('open').addClass('closed');
    var slideOutState = $.cookie('slideout_panel_state');
    var margin_settings = '';
    if(slideOutState === 'hidden'){
    	margin_settings = '0 6px 0 6px';
    }else{
    	margin_settings = '0 6px 0 284px';
    }
    $('#page').animate({margin:margin_settings},{ duration: 700, queue: false }, 'easeInSine', function(){});
    $.cookie('slideout_basket_state', 'hidden',{ path: '/' });
    setViewportWidth(true);
  }  
  $('.basket-toggle').click(function(){
    if( $('#basket').hasClass('open') ){    
      hideBasket();
    }else{
      hideBasket();
    }
	timeout='hide';
  return false;
  });	  
  if($('#your-shopping-cart').length != 0){
    hideBasket();
  }
  if(basketState === 'visible'){
    $('#basket').addClass('open');
  }  
  function showSlideOut(){
    $('#slideOut').animate({width: '280px'},{ duration: 700, queue: false }, 'easeInSine', function(){}).addClass('open').removeClass('closed');
    $('.slideOut-toggle').animate({left: '280px'}, { duration: 700, queue: false }, 'easeInSine', function(){}).addClass('open').removeClass('closed');
    var basket_panel_state = $.cookie('slideout_basket_state');
    var margin_settings = '';
    if(basket_panel_state === 'hidden'){
    	margin_settings = '0 0 0 284px';
    }else{
    	margin_settings = '0 234px 0 284px';
    }
    $('#page').animate({margin:margin_settings},{ duration: 700, queue: false }, 'easeInSine', function(){});
    $.cookie('slideout_panel_state', 'visible',{ path: '/' });
    setViewportWidth(true);
  }
  function hideSlideOut(){
    $('#slideOut').animate({width: '0px'},{ duration: 700, queue: false }, 'easeOutSine', function(){});
    $('.slideOut-toggle').animate({left: '6px'}, { duration: 700, queue: false }, 'easeInSine', function(){}).addClass('closed').removeClass('open');
    $('#slideOut').addClass('closed').removeClass('open');    
    var basket_panel_state = $.cookie('slideout_basket_state');
    var margin_settings = '';
    if(basket_panel_state === 'hidden' || basket_panel_state === 'undefined'){
    	margin_settings = '0 0 0 6px';
    }else{
    	margin_settings = '0 234px 0 6px';
    }
    $('#page').animate({margin:margin_settings},{ duration: 700, queue: false }, 'easeInSine', function(){});
    $.cookie('slideout_panel_state', 'hidden',{ path: '/' });
    setViewportWidth(true);      
  }
  $('.slideOut-toggle').click(function(){
    if( $('#slideOut').hasClass('open') ){    
      hideSlideOut();
    }else{
      showSlideOut();
    }
    timeout='hide';
  return false;
  });	

/************************
* SHOPPING CART - ref: https://cdn.shopify.com/s/shopify/api.jquery.js?a1c9e2b858c25e58ac6885c29833a7872fcea2ba
*************************/
$('#AddToCart').on("click",function() {
  var basketState = $.cookie('slideout_basket_state');
	if(basketState == 'hidden'){
	  hideBasket();
	}
}); 

 // Remove item from cart.
  $(document).on("click",".remove-item",function(event){   
    event.preventDefault(); 
    var vid = $(this).attr('href');
    vid = vid.replace('#','');
    var qty = parseInt($(this).attr('data-qty'));
    qty = qty - 1;
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: { id: vid, quantity:qty},
      success: function(html){
      buildCart();
      },
      dataType: 'json'
    });
  }); 

  // Increase item quantity from cart.
  $(document).on("click",".add-item",function(event){   
    event.preventDefault(); 
    var vid = $(this).attr('href');
    vid = vid.replace('#','');
    var qty = parseInt($(this).attr('data-qty'));
    qty = (qty + 1);
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: { id: vid, quantity:qty},
      success: function(html){
      buildCart();
      },
      dataType: 'json'
    });
  });
  
  // Build cart.
  function buildCart(){
    $.ajax({ 
      type: 'GET',
      url: '/cart.js',
      async: false, 
      cache: false, 
      dataType: 'json',
      success: function(response){
        // If the cart count is not empty.
        if(response.item_count > 0){
          $('#basket .cart-items').html('');       
          for (var i=0;i<response.items.length;i++){
            var item = response.items[i];            
            var title = item.title;
            var handle = item.handle;
            var type = '';
            // Load product data.
            $.ajax({ 
              type: 'GET',
              url: '/products/' + handle + '.js',
              async: false, 
              cache: false, 
              dataType: 'json',
              success: function(product){
                type = product.type.toLowerCase();
                type = type.replace(' ', '-');
              }
            });
            var url = item.url;
            //var url = '/collections/' + type + '/products/' + handle;            
            var vid = item.variant_id;
            var quantity = item.quantity;			
			//finds image, creates url, cartfinalimage used instead of item.image later in the table
			// https://ecommerce.shopify.com/c/ecommerce-design/t/jquery-inline-cart-storefront-api-67681
			var imageurl = (item.image);
			var varsize = ('small');
			var matches = imageurl.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
			var cartfinalimage =  (matches[1] + '_' + varsize + '.' + matches[2]);
			
            var price = Shopify.formatMoney(item.line_price);
            price = price.replace('$','');
            //price = price.replace(',','');            
            //price = Math.floor(price);
			
              // Add the line item to the cart.            
              $('#basket .cart-items').prepend('<li><div class="cart-descr"><a href="'+ url +'">'+ title +'</a></div><div class="cart-img"><a href="'+ url +'"><img src="'+ cartfinalimage +'"/></a></div><div class="cart-price">€ '+ $.trim(price) +'</a></div><div class="cart-quantity"><a href="#'+ vid +'" data-qty="'+ quantity +'" class="remove-item">-</a><a href="#'+ vid +'" data-qty="'+ quantity +'" class="add-item">+</a> Quantity: <strong>'+ quantity +'</strong></div>');}
          // Format and display the cart totals.
          var total_price = Shopify.formatMoney(response.total_price);
          total_price = total_price.replace('$','');
          //total_price = total_price.replace(',','');
          //total_price = Math.floor(total_price);          
          $('#basket .cart-items').append('<li id="cart-total">TOTAL: € '+ $.trim(total_price) +'</li>');
		  $('#basket .cart-items').append('<li id="vatmessage">Taxes will be calculated at checkout</li>');
          // Add the checkout button.
          $('#basket .cart-items').append('<li id="cart-checkout"><a class="checkoutbutton" href="/checkout">checkout</a></li>');
        }else{
          // The cart is empty, hide the basket.
          $('#basket').addClass('empty');
          hideBasket();
        }
      }
    });
  }
  // Build the cart on pageload.
  buildCart();

});